import styled from 'styled-components'
import { breakpoints } from '@/styles'

const StatusCreated = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 16px;
  padding: 4px 8px;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.color};
  font-weight: 500;
  font-size: 14px;
`
const StatusCreatedText = styled.span`
  margin-left: ${props => (props.icon ? '6px' : '0px')};
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    max-width: 150px;
  }
`

const Status = ({ icon, text, backgroundColor, color }) => {
  return (
    <StatusCreated backgroundColor={backgroundColor} color={color}>
      {icon} <StatusCreatedText icon={!!icon}>{text}</StatusCreatedText>
    </StatusCreated>
  )
}

export default Status
